import {WalletPlatform} from '@/enums/WalletPlatform'
import {$} from '@/facade'
import {TWalletInvocationBuilder} from '../types/WalletTypes'
import {N3InvocationBuilder} from './N3InvocationBuilder'
import {n3NeolineInvocationBuilder} from './N3NeolineInvocationBuilder'
import {n3NeonWalletInvocationBuilder} from './N3NeonWalletInvocationBuilder'
import {NeoXInvocationBuilder} from './NeoXInvocationBuilder'

const walletInvocationBuildersByWalletImplementation: TWalletInvocationBuilder = {
  n3: {
    [WalletPlatform.NEON]: n3NeonWalletInvocationBuilder,
    [WalletPlatform.NEOLINE]: n3NeolineInvocationBuilder,
  },
  neoX: {
    [WalletPlatform.NEON]: n3NeonWalletInvocationBuilder,
    [WalletPlatform.NEOLINE]: n3NeolineInvocationBuilder,
  },
}

const getCurrentWalletInvocationBuilder = (
  walletImplementation: 'n3' | 'neoX',
  walletPlatform: WalletPlatform
) => {
  return walletInvocationBuildersByWalletImplementation[walletImplementation][
    walletPlatform
  ]
}

export const getN3InvocationBuilder = () => {
  const walletPlatform = $.walletAdapter.n3ConnectedWalletPlatform

  if (!walletPlatform) {
    throw new Error('N3 wallet is not connected')
  }

  return getCurrentWalletInvocationBuilder(
    'n3',
    walletPlatform
  ) as N3InvocationBuilder
}

export const getXInvocationBuilder = () => {
  const walletPlatform = $.walletAdapter.xConnectedWalletPlatform

  if (!walletPlatform) {
    throw new Error('NeoX wallet is not connected')
  }

  return getCurrentWalletInvocationBuilder(
    'neoX',
    walletPlatform
  ) as NeoXInvocationBuilder
}
